import { getHelpersProperties } from '@/helpers';

export const infrastructureMixin = {
  computed: {
    infrastructure() {
      const routePathElements = this.$route.path.split('/');
      const infrastructure = routePathElements[routePathElements.length - 1];
      if (['synchrotron', 'cryoem'].includes(infrastructure)) {
        return infrastructure;
      }
      return '';
    },
  },
  methods: {
    async getEvaluationDashboardProperties(infrastructure, dashboardName) {
      return getHelpersProperties(`evaluation/${infrastructure}${dashboardName}`);
    },
    async getRapidAccessEvaluationDashboardProperties(infrastructure, dashboardName) {
      return getHelpersProperties(`evaluation/rapid-access/${infrastructure}RapidAccess${dashboardName}`);
    },
    isProposalOfInfrastructureType(proposal, infrastructure) {
      return proposal.document_specification.type === infrastructure;
    },
  },
};
